import { createContext, MutableRefObject, useContext, useEffect } from "react";

interface NavigationGuardContextValue {
  isDirtyRef: MutableRefObject<boolean>;
  resetRef: MutableRefObject<(() => void) | null>;
}

export const NavigationGuardContext =
  createContext<NavigationGuardContextValue | null>(null);

// Called by UtilityBillFormView to keep the guard refs up to date.
// Clears on unmount so a stale dirty flag doesn't survive to the next bill.
export const useNavigationGuardRegister = (
  isDirty: boolean,
  reset: () => void,
) => {
  const ctx = useContext(NavigationGuardContext);

  useEffect(() => {
    if (ctx) ctx.isDirtyRef.current = isDirty;
  }, [ctx, isDirty]);

  useEffect(() => {
    if (ctx) ctx.resetRef.current = reset;
    return () => {
      if (ctx) {
        ctx.isDirtyRef.current = false;
        ctx.resetRef.current = null;
      }
    };
  // reset identity is stable (react-hook-form memoises it), so this is safe.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx]);
};
